import type { Credential } from "@/types";

import { publicClient, type RequestOptions } from "./public-client";
import { loginResponseSchema } from "./schemas";

function login(credential: Credential, options?: RequestOptions) {
  return publicClient
    .post("/v2/login", { ...options, json: credential })
    .json(loginResponseSchema);
}

async function resetPassword(email: string, options?: RequestOptions) {
  await publicClient.post("/v2/reset-password", {
    ...options,
    json: { email },
  });
}

const authApi = { login, resetPassword };

export { authApi as AuthApi };
